export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    addCity: function addCity() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/city/add",
        method: "post",
        data: data
      });
    },
    getCityList: function getCityList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/city/get",
        method: "get",
        params: data
      });
    },
    getCityListByPy: function getCityListByPy() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/resource/citys/",
        method: "get",
        params: data
      });
    },
    updateCity: function updateCity() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/city/update",
        method: "post",
        data: data
      });
    },
    updateCityStatus: function updateCityStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/city/updateStatus",
        method: "post",
        data: data
      });
    },
    //草稿<->待开放城市切换
    updateCityDraft: function updateCityDraft() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/city/updateDraft",
        method: "post",
        data: data
      });
    },
    getCityStrategyInfo: function getCityStrategyInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "admin/city_strategy/getInfo",
        method: "get",
        params: data
      });
    },
    updateCityStrategy: function updateCityStrategy() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/city_strategy/update",
        method: "post",
        data: data
      });
    },
    updateCityOrder: function updateCityOrder() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/city/updateOrder",
        method: "post",
        data: data
      });
    },
    updateFrontendCityList: function updateFrontendCityList() {
      return request({
        url: "/api/v3/job/cacheCityGroupListJob",
        method: "get"
      });
    },
    clearHotListCache: function clearHotListCache() {
      return request({
        url: "/api/v3/admin/city/clearHotListCache",
        method: "post"
      });
    }
  };
});